import { supabase } from '../lib/supabase';

export const originService = {
  // Predefined origins first (by sort order), then the user's own (A to Z).
  async list() {
    const { data, error } = await supabase
      .from('moment_origins')
      .select('id, owner_id, label, sort_order');
    if (error) throw error;
    return (data || []).sort((a, b) => {
      const aCustom = a.owner_id ? 1 : 0;
      const bCustom = b.owner_id ? 1 : 0;
      if (aCustom !== bCustom) return aCustom - bCustom;
      if (!aCustom) return a.sort_order - b.sort_order;
      return a.label.localeCompare(b.label);
    });
  },

  async create(ownerId, label) {
    const { data, error } = await supabase
      .from('moment_origins')
      .insert({ owner_id: ownerId, label: label.trim() })
      .select('id, owner_id, label, sort_order')
      .single();
    if (error) throw error;
    return data;
  },

  // Moments using this origin simply lose it (database sets origin_id to null).
  async remove(id) {
    const { error } = await supabase.from('moment_origins').delete().eq('id', id);
    if (error) throw error;
  }
};